import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { API, ITENSPORPAGINA } from 'src/app/app.config';
import { BuscaCarroRQ } from 'src/app/model';

@Injectable()
export class CarroService {

    constructor(
        private http: HttpClient
    ) { }

    buscarPorParametro(param: string, pagina: Number) {
        const headers = new HttpHeaders().set("noloader", "t");

        if (param.length > 0) {
            return this.http.get<any>(`${API}/api/lojascarro/list/${param.trim()}?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}`, { headers: headers });
        } else {
            return this.http.get<any>(`${API}/api/lojascarro?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}`, { headers: headers });
        }
    }

    buscarCarro(busca: BuscaCarroRQ, pagina: Number): Observable<any> {
        return this.http.post<any>(`${API}/api/Carro/busca?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}`, busca, { headers: new HttpHeaders().set('noloader', 'true') });
    }

    removerCarro(carro: any): Observable<any> {
        return this.http.delete<any>(`${API}/api/Carro/${carro.Id}`);
    }

    reservarCarro(carro: any): Observable<any> {
        return this.http.post<any>(`${API}/api/carro/reservar/${carro.Id}`, carro, { headers: new HttpHeaders().set('noloader', 'true') });
    }

    atualizarStatusCarro(carro: any): Observable<any> {
        return this.http.patch<any>(`${API}/api/carro/atualizar/${carro.Id}`, {}, { headers: new HttpHeaders().set('noloader', 'true') });
    }

    cancelarCarro(carro: any): Observable<any> {
        return this.http.post<any>(`${API}/api/carro/cancelar/${carro.ReservaId}/${carro.Id}`, {}, { headers: new HttpHeaders().set('noloader', 'true') });
    }
}
